import { MapTo } from '@adobe/aem-react-editable-components';
import RecommendedArticles, { RecommendedArticlesEditConfig } from './RecommendedArticles';

export default MapTo('cob-corp-acquisition/components/creditonebank/recommended-articles')(RecommendedArticles, RecommendedArticlesEditConfig);